import axios from 'axios';
import { newAbortSignal } from '../../utils';
import { SessionStore } from '../../types/store/SessionStore';

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/account/`; 

export const getAvatar = async (accountId: number, userId: number): Promise<Blob | null> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem('session') || '{}'
  );

  const finalURL = `${BASE_URL}${accountId}/user/${userId}/avatar`;

  try {
    const response = await axios.get(finalURL, {
      headers: {
        'x-access-token': session?.accessToken,
      },
      responseType: 'blob',
      timeout: parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        typeof AbortSignal.timeout !== 'undefined'
          ? AbortSignal.timeout(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`))
          : newAbortSignal(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)),
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching avatar:", error);
    return null;
  }
};
